import { IWebflowPartnerSignUpTypes } from "@wingspanhq/cms/dist/lib/interfaces/webflow/partners";
import { Filters } from "@wingspanhq/fe-component-library";
import { GrowthAttributionDetails } from "../utils/growthAttribution";
import { createWSStore } from "../utils/WSStore";

export type WSStore = {
  appContext: {
    isEmbedded: boolean;
  };
  bankCardTokens: {
    token?: string;
    ids: { [wsCardId: string]: string };
  };
  captchaScriptIsLoaded: boolean;
  createdWithPPL: boolean;
  discountCode: string;
  growthAttributionDetails?: GrowthAttributionDetails;
  isEmployerSignUp?: boolean;
  is1099SignUp?: boolean;
  isPartnerSignUp: boolean;
  isPaymentsServiceReEnabled?: boolean;
  productActivationAfterOnboarding?: boolean;
  signUpHash?: string;
  signUpMethod?: "Google" | "Email";
  signUpType: IWebflowPartnerSignUpTypes;

  savedFilters: {
    [path: string]: Filters;
  };
  invoiceFormBackPath?: string;
};

export const wsStore = createWSStore<WSStore>(() => ({
  appContext: {
    isEmbedded: process.env.REACT_APP_BUILD_TARGET !== "app"
  },
  createdWithPPL: false,
  signUpType: IWebflowPartnerSignUpTypes.AllInOne,
  discountCode: "",
  captchaScriptIsLoaded: !!window.wingspanReCaptchaOnLoad,
  isPartnerSignUp: false,
  isEmployerSignUp: false,
  is1099SignUp: false,
  bankCardTokens: {
    ids: {}
  },
  savedFilters: {}
}));

export const useWSStore = wsStore.useWSStore;
export const useSetWSStore = wsStore.useSetWSStore;
export const useResetWSStore = wsStore.useResetWSStore;
